import { Link } from "react-router-dom";
import { CheckCircle2, Hourglass } from "lucide-react";
import { useI18n } from "../../../i18n";

export const OrderPlaced = ({ result }) => {
  const { t } = useI18n();
  const pending = result.status !== "submitted";
  const Icon = pending ? Hourglass : CheckCircle2;
  return (
    <div data-testid="order-placed" className="mx-auto max-w-md rounded-3xl bg-white px-6 py-10 text-center shadow-sm animate-in fade-in zoom-in-95 duration-500">
      <span className={`mx-auto grid h-16 w-16 place-items-center rounded-full ${pending ? "bg-amber-100 text-amber-700" : "bg-brand/15 text-brand"}`}><Icon className="h-8 w-8" /></span>
      <h1 className="mt-5 text-2xl font-bold text-navy" data-testid="order-placed-title">{t(result.status === "in_review" ? "checkout.reviewTitle" : pending ? "checkout.pendingTitle" : "checkout.placedTitle")}</h1>
      {pending ? <p className="mt-2 text-sm text-slate-600">{t(result.status === "in_review" ? "checkout.reviewSub" : "checkout.pendingSub")}</p> : (
        <>
          <p className="mt-2 text-sm text-slate-500">{t("checkout.placedSub")}</p>
          <p className="mt-1 text-3xl font-extrabold tracking-tight text-navy tabular-nums" data-testid="order-placed-doc-no">{result.doc_no}</p>
        </>
      )}
      <div className="mt-8 flex flex-col gap-2">
        <Link to={`/app/orders/${result.local_id}`} data-testid="order-placed-view" className="flex h-12 items-center justify-center rounded-full bg-navy text-sm font-semibold text-white">{t("checkout.viewOrders")}</Link>
        <Link to="/app" data-testid="order-placed-home" className="flex h-12 items-center justify-center rounded-full text-sm font-semibold text-navy hover:bg-slate-50">{t("checkout.backHome")}</Link>
      </div>
    </div>
  );
};
